"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getElementsFromRecords_1 = __importDefault(require("./getElementsFromRecords"));

exports.getElementsFromRecords = getElementsFromRecords_1.default;

var InferredElement_1 = __importDefault(require("./InferredElement"));

exports.InferredElement = InferredElement_1.default;